'use client';
import React, { useState } from 'react';
import AppLayout from '@/components/AppLayout';
import { Search, Heart, ShoppingCart, Star, MapPin, X, ChevronLeft, ChevronRight, SlidersHorizontal, Package, Truck, RotateCcw, Shield, Plus, Minus, Check, MessageCircle, Phone } from 'lucide-react';

// ─── Types ────────────────────────────────────────────────────────────────────
interface Product {
  id: string;
  name: string;
  price: number;
  originalPrice: number;
  image: string;
  category: string;
  subcategory: string;
  condition: string;
  colors: string[];
  sizes: string[];
  seller: string;
  sellerLocation: string;
  sellerRating: number;
  stock: number;
  rating: number;
  reviews: number;
  delivery: string;
  returnPolicy: string;
  badge?: string;
}

// ─── Mock Data ────────────────────────────────────────────────────────────────
const PRODUCTS: Product[] = [
{ id: 'bf-001', name: 'Ankara Print Maxi Dress', price: 2800, originalPrice: 3500, image: "https://img.rocket.new/generatedImages/rocket_gen_img_159f14c52-1778003518461.png", category: 'Fashion', subcategory: "Women's Clothes", condition: 'Brand New', colors: ['Blue', 'Orange', 'Green'], sizes: ['S', 'M', 'L', 'XL'], seller: 'Mama Nguo Store', sellerLocation: 'Nairobi, Kenya', sellerRating: 4.8, stock: 24, rating: 4.7, reviews: 156, delivery: 'Nairobi same day, nationwide 2-3 days', returnPolicy: '7-day returns', badge: 'HOT' },
{ id: 'bf-002', name: 'Men\'s Slim Fit Suit - Navy', price: 8500, originalPrice: 12000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1321b1976-1771908952064.png", category: 'Fashion', subcategory: "Men's Clothes", condition: 'Brand New', colors: ['Navy', 'Black', 'Charcoal'], sizes: ['38', '40', '42', '44', '46'], seller: 'Executive Wear KE', sellerLocation: 'Westlands, Nairobi', sellerRating: 4.9, stock: 12, rating: 4.8, reviews: 89, delivery: 'Nationwide 2-3 days', returnPolicy: '14-day returns', badge: 'SALE' },
{ id: 'bf-003', name: 'MAC Foundation Studio Fix', price: 3200, originalPrice: 3200, image: "https://img.rocket.new/generatedImages/rocket_gen_img_180c7354c-1768162243812.png", category: 'Beauty', subcategory: 'Makeup', condition: 'Brand New', colors: ['NC15', 'NC25', 'NC35', 'NC45'], sizes: ['30ml'], seller: 'Beauty Hub Kenya', sellerLocation: 'CBD, Nairobi', sellerRating: 4.7, stock: 45, rating: 4.6, reviews: 234, delivery: 'Nairobi same day', returnPolicy: 'No returns on beauty', badge: 'NEW' },
{ id: 'bf-004', name: 'Brazilian Human Hair Wig 18"', price: 15000, originalPrice: 18000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_158e6f208-1765685015453.png", category: 'Beauty', subcategory: 'Human-hair Wigs', condition: 'Brand New', colors: ['Natural Black', 'Dark Brown', '1B/30'], sizes: ['16"', '18"', '20"', '22"'], seller: 'Queens Hair Collection', sellerLocation: 'Kilimani, Nairobi', sellerRating: 4.9, stock: 8, rating: 4.9, reviews: 312, delivery: 'Nationwide 2-3 days', returnPolicy: '3-day returns if unused', badge: 'TOP' },
{ id: 'bf-005', name: 'Nike Air Force 1 Sneakers', price: 9500, originalPrice: 11000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_159f14c52-1778003518461.png", category: 'Fashion', subcategory: 'Sneakers', condition: 'Brand New', colors: ['White', 'Black', 'Triple White'], sizes: ['38', '39', '40', '41', '42', '43', '44'], seller: 'Kicks Kenya', sellerLocation: 'Westlands, Nairobi', sellerRating: 4.8, stock: 30, rating: 4.8, reviews: 445, delivery: 'Nairobi same day, nationwide 2-3 days', returnPolicy: '7-day returns', badge: 'HOT' },
{ id: 'bf-006', name: 'Chanel No. 5 Perfume 100ml', price: 12000, originalPrice: 15000, image: "https://images.unsplash.com/photo-1626785470282-8a5d09328d79", category: 'Beauty', subcategory: 'Perfumes', condition: 'Brand New', colors: ['Original'], sizes: ['50ml', '100ml', '200ml'], seller: 'Luxury Scents KE', sellerLocation: 'Karen, Nairobi', sellerRating: 4.9, stock: 15, rating: 4.9, reviews: 178, delivery: 'Nationwide 3-5 days', returnPolicy: 'No returns on opened perfumes', badge: 'LUXURY' },
{ id: 'bf-007', name: 'Ex-UK Zara Floral Dress', price: 1200, originalPrice: 2500, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1aaa5e60e-1772151282034.png", category: 'Fashion', subcategory: 'Ex-UK Clothes', condition: 'Used – Excellent', colors: ['Floral Print'], sizes: ['S', 'M', 'L'], seller: 'Mitumba Palace', sellerLocation: 'Gikomba, Nairobi', sellerRating: 4.5, stock: 1, rating: 4.5, reviews: 67, delivery: 'Nairobi same day', returnPolicy: 'No returns on second-hand', badge: 'EX-UK' },
{ id: 'bf-008', name: 'Michael Kors Leather Handbag', price: 8900, originalPrice: 8900, image: "https://images.unsplash.com/photo-1712704056734-4c599f407009", category: 'Fashion', subcategory: 'Handbags', condition: 'Brand New', colors: ['Black', 'Brown', 'Tan'], sizes: ['One Size'], seller: 'Luxury Bags KE', sellerLocation: 'Westlands, Nairobi', sellerRating: 4.7, stock: 6, rating: 4.7, reviews: 92, delivery: 'Nationwide 2-3 days', returnPolicy: '7-day returns', badge: 'NEW' },
{ id: 'bf-009', name: 'Fenty Beauty Gloss Bomb', price: 2800, originalPrice: 3200, image: 'https://images.unsplash.com/photo-1586495777744-4e6232bf2f9d?w=400', category: 'Beauty', subcategory: 'Makeup', condition: 'Brand New', colors: ['Fenty Glow', 'Hot Chocolit', 'Candy Drip'], sizes: ['9ml'], seller: 'Glam Studio KE', sellerLocation: 'Kilimani, Nairobi', sellerRating: 4.8, stock: 28, rating: 4.8, reviews: 203, delivery: 'Nairobi same day', returnPolicy: 'No returns on beauty', badge: 'SALE' },
{ id: 'bf-010', name: 'Levi\'s 501 Original Jeans', price: 4500, originalPrice: 6000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_170fa58ff-1772641226004.png", category: 'Fashion', subcategory: 'Jeans', condition: 'Brand New', colors: ['Dark Blue', 'Light Blue', 'Black'], sizes: ['28', '30', '32', '34', '36'], seller: 'Denim World KE', sellerLocation: 'Mombasa Road, Nairobi', sellerRating: 4.6, stock: 40, rating: 4.6, reviews: 321, delivery: 'Nationwide 2-3 days', returnPolicy: '14-day returns', badge: 'SALE' },
{ id: 'bf-011', name: 'OGX Argan Oil Shampoo', price: 1800, originalPrice: 2200, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1eabd1283-1764752235958.png", category: 'Beauty', subcategory: 'Hair Products', condition: 'Brand New', colors: ['Original'], sizes: ['385ml', '577ml'], seller: 'Hair Care Kenya', sellerLocation: 'Westlands, Nairobi', sellerRating: 4.7, stock: 55, rating: 4.7, reviews: 189, delivery: 'Nationwide 2-3 days', returnPolicy: '7-day returns if unopened', badge: 'NEW' },
{ id: 'bf-012', name: 'African Print Kitenge Suit', price: 5500, originalPrice: 7000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a5ee5241-1768476846526.png", category: 'Fashion', subcategory: 'African Wear', condition: 'Brand New', colors: ['Blue/Gold', 'Red/Black', 'Green/Yellow'], sizes: ['S', 'M', 'L', 'XL', 'XXL'], seller: 'African Threads', sellerLocation: 'Eastleigh, Nairobi', sellerRating: 4.8, stock: 18, rating: 4.8, reviews: 134, delivery: 'Nationwide 2-3 days', returnPolicy: '7-day returns', badge: 'HOT' },
{ id: 'bf-013', name: 'Salon Professional Hair Dryer', price: 6500, originalPrice: 8000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f48af49d-1768928207220.png", category: 'Beauty', subcategory: 'Salon Equipment', condition: 'Brand New', colors: ['Black', 'Rose Gold'], sizes: ['2200W'], seller: 'Pro Salon Supplies', sellerLocation: 'Industrial Area, Nairobi', sellerRating: 4.6, stock: 22, rating: 4.6, reviews: 78, delivery: 'Nationwide 3-5 days', returnPolicy: '14-day returns', badge: 'NEW' },
{ id: 'bf-014', name: 'Bridal Lace Wedding Gown', price: 35000, originalPrice: 45000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1350af0f2-1773194628522.png", category: 'Fashion', subcategory: 'Bridal Wear', condition: 'Brand New', colors: ['Ivory', 'White', 'Champagne'], sizes: ['S', 'M', 'L', 'Custom'], seller: 'Bridal Dreams KE', sellerLocation: 'Lavington, Nairobi', sellerRating: 4.9, stock: 5, rating: 4.9, reviews: 56, delivery: 'Nationwide 5-7 days', returnPolicy: 'No returns on bridal wear', badge: 'LUXURY' },
{ id: 'bf-015', name: 'Neutrogena Hydro Boost Moisturizer', price: 2200, originalPrice: 2800, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1eabd1283-1764752235958.png", category: 'Beauty', subcategory: 'Skincare', condition: 'Brand New', colors: ['Original'], sizes: ['50ml', '100ml'], seller: 'Skin Glow Kenya', sellerLocation: 'Parklands, Nairobi', sellerRating: 4.7, stock: 60, rating: 4.7, reviews: 267, delivery: 'Nairobi same day', returnPolicy: '7-day returns if unopened', badge: 'SALE' },
{ id: 'bf-016', name: 'Plus Size Maxi Skirt', price: 1800, originalPrice: 2500, image: 'https://images.unsplash.com/photo-1594938298603-c8148c4b4357?w=400', category: 'Fashion', subcategory: 'Plus-size Fashion', condition: 'Brand New', colors: ['Black', 'Navy', 'Burgundy'], sizes: ['2XL', '3XL', '4XL', '5XL'], seller: 'Curves & Style KE', sellerLocation: 'Nairobi, Kenya', sellerRating: 4.6, stock: 35, rating: 4.6, reviews: 112, delivery: 'Nationwide 2-3 days', returnPolicy: '7-day returns', badge: 'NEW' },
{ id: 'bf-017', name: 'Rolex Submariner Watch (Replica)', price: 4500, originalPrice: 5500, image: "https://images.unsplash.com/photo-1605293790133-8cf0edc62eea", category: 'Fashion', subcategory: 'Watches', condition: 'Brand New', colors: ['Silver/Black', 'Gold/Blue', 'All Black'], sizes: ['One Size'], seller: 'Time Pieces KE', sellerLocation: 'CBD, Nairobi', sellerRating: 4.4, stock: 20, rating: 4.4, reviews: 88, delivery: 'Nationwide 2-3 days', returnPolicy: '7-day returns', badge: 'HOT' },
{ id: 'bf-018', name: 'Barber Clipper Professional Set', price: 8500, originalPrice: 10000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1547d8d9b-1765940392060.png", category: 'Beauty', subcategory: 'Barber Equipment', condition: 'Brand New', colors: ['Black', 'Silver'], sizes: ['Complete Set'], seller: 'Barber Pro Kenya', sellerLocation: 'Thika Road, Nairobi', sellerRating: 4.8, stock: 14, rating: 4.8, reviews: 145, delivery: 'Nationwide 3-5 days', returnPolicy: '14-day returns', badge: 'NEW' }];


const CATEGORIES = ['All', 'Fashion', 'Beauty'];
const SUBCATEGORIES: Record<string, string[]> = {
  Fashion: ["Women's Clothes", "Men's Clothes", "Children's Clothes", 'Dresses', 'Suits', 'T-shirts', 'Shirts', 'Trousers', 'Jeans', 'Jackets', 'Sweaters', 'Sportswear', 'School Uniforms', 'Shoes', 'Sandals', 'Heels', 'Sneakers', 'Handbags', 'Wallets', 'Watches', 'Jewellery', 'Sunglasses', 'Belts', 'Caps & Hats', 'African Wear', 'Muslim Fashion', 'Bridal Wear', 'Maternity Clothes', 'Plus-size Fashion', 'Second-hand Clothes', 'Ex-UK Clothes'],
  Beauty: ['Makeup', 'Skincare', 'Hair Products', 'Human-hair Wigs', 'Synthetic Wigs', 'Braids & Extensions', 'Perfumes', 'Body Sprays', 'Lotions', 'Nail Products', 'Manicure Products', 'Pedicure Products', 'Eyelashes', 'Eyebrow Products', 'Salon Equipment', 'Barber Equipment', 'Massage Products', 'Personal-care Products', "Men's Grooming", 'Beauty Tools']
};

const ITEMS_PER_PAGE = 6;

const badgeColors: Record<string, {bg: string;text: string;}> = {
  HOT: { bg: '#FF3B5C', text: '#fff' },
  SALE: { bg: '#FFB300', text: '#000' },
  NEW: { bg: '#00C853', text: '#000' },
  TOP: { bg: '#7C4DFF', text: '#fff' },
  LUXURY: { bg: '#C9A84C', text: '#000' },
  'EX-UK': { bg: '#00BCD4', text: '#000' }
};

// ─── Product Detail Modal ─────────────────────────────────────────────────────
function ProductDetailModal({ product, onClose, onAddToCart, onAddToWishlist, wishlist





}: {product: Product;onClose: () => void;onAddToCart: (p: Product, qty: number, color: string, size: string) => void;onAddToWishlist: (id: string) => void;wishlist: Set<string>;}) {
  const [qty, setQty] = useState(1);
  const [selectedColor, setSelectedColor] = useState(product.colors[0]);
  const [selectedSize, setSelectedSize] = useState(product.sizes[0]);
  const [added, setAdded] = useState(false);

  const discount = Math.round((1 - product.price / product.originalPrice) * 100);

  const handleAddToCart = () => {
    onAddToCart(product, qty, selectedColor, selectedSize);
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end lg:items-center justify-center">
      <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(6px)' }} onClick={onClose} />
      <div className="relative w-full max-w-lg rounded-t-3xl lg:rounded-3xl max-h-[92vh] overflow-y-auto" style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>
        <div className="sticky top-0 z-10 flex items-center justify-between px-5 py-4" style={{ background: 'var(--card)', borderBottom: '1px solid var(--border)' }}>
          <h3 className="text-sm font-700 text-foreground truncate pr-4">{product.name}</h3>
          <button onClick={onClose} className="p-2 rounded-xl flex-shrink-0" style={{ border: '1px solid var(--border)' }}>
            <X size={16} style={{ color: 'var(--muted-foreground)' }} />
          </button>
        </div>

        <div className="relative">
          <img src={product.image} alt={product.name} className="w-full h-64 object-cover" />
          {product.badge &&
          <span className="absolute top-3 left-3 px-2 py-1 rounded-lg text-xs font-700"
          style={{ background: badgeColors[product.badge]?.bg || '#00C853', color: badgeColors[product.badge]?.text || '#000' }}>
              {product.badge}
            </span>
          }
          <button onClick={() => onAddToWishlist(product.id)}
          className="absolute top-3 right-3 w-9 h-9 rounded-full flex items-center justify-center"
          style={{ background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}>
            <Heart size={18} fill={wishlist.has(product.id) ? '#FF3B5C' : 'none'} style={{ color: wishlist.has(product.id) ? '#FF3B5C' : '#fff' }} />
          </button>
        </div>

        <div className="px-5 py-4 flex flex-col gap-4">
          <div>
            <h2 className="text-lg font-700 text-foreground mb-1">{product.name}</h2>
            <div className="flex items-center gap-3">
              <span className="text-2xl font-800" style={{ color: 'var(--primary)' }}>KES {product.price.toLocaleString()}</span>
              {product.originalPrice > product.price &&
              <>
                  <span className="text-sm line-through" style={{ color: 'var(--muted-foreground)' }}>KES {product.originalPrice.toLocaleString()}</span>
                  <span className="text-xs font-700 px-2 py-0.5 rounded-lg" style={{ background: 'rgba(255,59,92,0.12)', color: '#FF3B5C' }}>-{discount}%</span>
                </>
              }
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1">
              {Array.from({ length: 5 }).map((_, i) =>
              <Star key={i} size={14} fill={i < Math.floor(product.rating) ? '#FFB300' : 'none'} style={{ color: '#FFB300' }} />
              )}
              <span className="text-sm font-700 text-foreground ml-1">{product.rating}</span>
            </div>
            <span className="text-xs" style={{ color: 'var(--muted-foreground)' }}>({product.reviews} reviews)</span>
            <span className="text-xs px-2 py-0.5 rounded-lg" style={{ background: 'rgba(0,200,83,0.1)', color: 'var(--primary)' }}>{product.condition}</span>
          </div>

          {product.colors.length > 1 &&
          <div>
              <p className="text-xs font-700 text-foreground mb-2">Color: <span style={{ color: 'var(--primary)' }}>{selectedColor}</span></p>
              <div className="flex flex-wrap gap-2">
                {product.colors.map((c) =>
              <button key={c} onClick={() => setSelectedColor(c)}
              className="px-3 py-1.5 rounded-xl text-xs font-600 transition-all"
              style={{ background: selectedColor === c ? 'rgba(0,200,83,0.15)' : 'var(--secondary)', border: `1.5px solid ${selectedColor === c ? 'var(--primary)' : 'var(--border)'}`, color: selectedColor === c ? 'var(--primary)' : 'var(--muted-foreground)' }}>
                    {c}
                  </button>
              )}
              </div>
            </div>
          }

          {product.sizes.length > 1 &&
          <div>
              <p className="text-xs font-700 text-foreground mb-2">Size: <span style={{ color: 'var(--primary)' }}>{selectedSize}</span></p>
              <div className="flex flex-wrap gap-2">
                {product.sizes.map((s) =>
              <button key={s} onClick={() => setSelectedSize(s)}
              className="px-3 py-1.5 rounded-xl text-xs font-600 transition-all"
              style={{ background: selectedSize === s ? 'rgba(0,200,83,0.15)' : 'var(--secondary)', border: `1.5px solid ${selectedSize === s ? 'var(--primary)' : 'var(--border)'}`, color: selectedSize === s ? 'var(--primary)' : 'var(--muted-foreground)' }}>
                    {s}
                  </button>
              )}
              </div>
            </div>
          }

          <div className="flex items-center gap-3">
            <p className="text-xs font-700 text-foreground">Quantity:</p>
            <div className="flex items-center gap-2">
              <button onClick={() => setQty((q) => Math.max(1, q - 1))} className="w-8 h-8 rounded-xl flex items-center justify-center" style={{ background: 'var(--secondary)', border: '1px solid var(--border)' }}>
                <Minus size={14} style={{ color: 'var(--foreground)' }} />
              </button>
              <span className="text-sm font-700 text-foreground w-6 text-center">{qty}</span>
              <button onClick={() => setQty((q) => Math.min(product.stock, q + 1))} className="w-8 h-8 rounded-xl flex items-center justify-center" style={{ background: 'var(--secondary)', border: '1px solid var(--border)' }}>
                <Plus size={14} style={{ color: 'var(--foreground)' }} />
              </button>
            </div>
            <span className="text-xs" style={{ color: 'var(--muted-foreground)' }}>{product.stock} in stock</span>
          </div>

          <div className="p-3 rounded-2xl" style={{ background: 'var(--secondary)', border: '1px solid var(--border)' }}>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-700" style={{ background: 'rgba(0,200,83,0.15)', color: 'var(--primary)' }}>
                {product.seller.charAt(0)}
              </div>
              <div>
                <p className="text-xs font-700 text-foreground">{product.seller}</p>
                <div className="flex items-center gap-1">
                  <MapPin size={10} style={{ color: 'var(--muted-foreground)' }} />
                  <span className="text-[10px]" style={{ color: 'var(--muted-foreground)' }}>{product.sellerLocation}</span>
                </div>
              </div>
              <div className="ml-auto flex items-center gap-1">
                <Star size={11} fill="#FFB300" style={{ color: '#FFB300' }} />
                <span className="text-xs font-700 text-foreground">{product.sellerRating}</span>
              </div>
            </div>
            <div className="flex gap-2">
              <button className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl text-xs font-600" style={{ background: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.3)', color: '#25D366' }}>
                <MessageCircle size={12} />Chat
              </button>
              <button className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl text-xs font-600" style={{ background: 'var(--secondary)', border: '1px solid var(--border)', color: 'var(--foreground)' }}>
                <Phone size={12} />Call
              </button>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-2">
            {[
            { icon: Truck, label: product.delivery, color: '#00BCD4' },
            { icon: RotateCcw, label: product.returnPolicy, color: '#FFB300' },
            { icon: Shield, label: 'Buyer Protection', color: '#00C853' }].
            map((item, i) => {
              const ItemIcon = item.icon;
              return (
                <div key={i} className="flex flex-col items-center gap-1 p-2 rounded-xl text-center" style={{ background: 'var(--secondary)' }}>
                  <ItemIcon size={16} style={{ color: item.color }} />
                  <span className="text-[9px] leading-tight" style={{ color: 'var(--muted-foreground)' }}>{item.label}</span>
                </div>);

            })}
          </div>

          <div className="flex gap-3">
            <button onClick={() => onAddToWishlist(product.id)}
            className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0"
            style={{ background: wishlist.has(product.id) ? 'rgba(255,59,92,0.12)' : 'var(--secondary)', border: `1.5px solid ${wishlist.has(product.id) ? '#FF3B5C' : 'var(--border)'}` }}>
              <Heart size={20} fill={wishlist.has(product.id) ? '#FF3B5C' : 'none'} style={{ color: wishlist.has(product.id) ? '#FF3B5C' : 'var(--muted-foreground)' }} />
            </button>
            <button onClick={handleAddToCart}
            className="flex-1 flex items-center justify-center gap-2 py-3.5 rounded-2xl text-sm font-700 transition-all"
            style={{ background: added ? 'rgba(0,200,83,0.2)' : 'var(--primary)', color: added ? 'var(--primary)' : '#001A08', border: added ? '1.5px solid var(--primary)' : 'none' }}>
              {added ? <><Check size={18} />Added to Cart</> : <><ShoppingCart size={18} />Add to Cart — KES {(product.price * qty).toLocaleString()}</>}
            </button>
          </div>
        </div>
      </div>
    </div>);

}

// ─── Cart Drawer ──────────────────────────────────────────────────────────────
interface CartItem {product: Product;qty: number;color: string;size: string;}

function CartDrawer({ cart, onClose, onRemove, onUpdateQty




}: {cart: CartItem[];onClose: () => void;onRemove: (id: string) => void;onUpdateQty: (id: string, qty: number) => void;}) {
  const [checkoutStep, setCheckoutStep] = useState<'cart' | 'checkout' | 'success'>('cart');
  const total = cart.reduce((s, item) => s + item.product.price * item.qty, 0);

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }} onClick={onClose} />
      <div className="relative w-full max-w-sm h-full flex flex-col" style={{ background: 'var(--card)', borderLeft: '1px solid var(--border)' }}>
        <div className="flex items-center justify-between px-5 py-4" style={{ borderBottom: '1px solid var(--border)' }}>
          <h3 className="text-base font-700 text-foreground">
            {checkoutStep === 'cart' ? `Cart (${cart.length})` : checkoutStep === 'checkout' ? 'Checkout' : 'Order Placed!'}
          </h3>
          <button onClick={onClose} className="p-2 rounded-xl" style={{ border: '1px solid var(--border)' }}>
            <X size={16} style={{ color: 'var(--muted-foreground)' }} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-4">
          {checkoutStep === 'cart' && (
          cart.length === 0 ?
          <div className="flex flex-col items-center justify-center h-full gap-4">
                <ShoppingCart size={48} style={{ color: 'var(--muted-foreground)', opacity: 0.3 }} />
                <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>Your cart is empty</p>
              </div> :

          <div className="flex flex-col gap-3">
                {cart.map((item) =>
            <div key={item.product.id} className="flex gap-3 p-3 rounded-2xl" style={{ background: 'var(--secondary)', border: '1px solid var(--border)' }}>
                    <img src={item.product.image} alt={item.product.name} className="w-16 h-16 rounded-xl object-cover flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <p className="text-xs font-700 text-foreground truncate">{item.product.name}</p>
                      <p className="text-[10px] mt-0.5" style={{ color: 'var(--muted-foreground)' }}>{item.color} · {item.size}</p>
                      <p className="text-sm font-800 mt-1" style={{ color: 'var(--primary)' }}>KES {(item.product.price * item.qty).toLocaleString()}</p>
                      <div className="flex items-center gap-2 mt-2">
                        <button onClick={() => onUpdateQty(item.product.id, Math.max(1, item.qty - 1))} className="w-6 h-6 rounded-lg flex items-center justify-center" style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>
                          <Minus size={10} style={{ color: 'var(--foreground)' }} />
                        </button>
                        <span className="text-xs font-700 text-foreground">{item.qty}</span>
                        <button onClick={() => onUpdateQty(item.product.id, item.qty + 1)} className="w-6 h-6 rounded-lg flex items-center justify-center" style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>
                          <Plus size={10} style={{ color: 'var(--foreground)' }} />
                        </button>
                        <button onClick={() => onRemove(item.product.id)} className="ml-auto p-1 rounded-lg" style={{ color: '#FF3B5C' }}>
                          <X size={14} />
                        </button>
                      </div>
                    </div>
                  </div>
            )}
              </div>)

          }

          {checkoutStep === 'checkout' &&
          <div className="flex flex-col gap-4">
              <div className="p-4 rounded-2xl" style={{ background: 'var(--secondary)', border: '1px solid var(--border)' }}>
                <p className="text-xs font-700 mb-3" style={{ color: 'var(--muted-foreground)' }}>DELIVERY DETAILS</p>
                {['Full Name', 'Phone Number', 'Delivery Address', 'City'].map((field) =>
              <div key={field} className="mb-3">
                    <label className="text-xs font-600 text-foreground block mb-1">{field}</label>
                    <input className="w-full px-3 py-2.5 rounded-xl text-sm outline-none" placeholder={`Enter ${field.toLowerCase()}`}
                style={{ background: 'var(--input)', border: '1px solid var(--border)', color: 'var(--foreground)' }} />
                  </div>
              )}
              </div>
              <div className="p-4 rounded-2xl" style={{ background: 'var(--secondary)', border: '1px solid var(--border)' }}>
                <p className="text-xs font-700 mb-3" style={{ color: 'var(--muted-foreground)' }}>ORDER SUMMARY</p>
                {cart.map((item) =>
              <div key={item.product.id} className="flex justify-between py-1.5 border-b last:border-0" style={{ borderColor: 'var(--border)' }}>
                    <span className="text-xs text-foreground">{item.product.name} ×{item.qty}</span>
                    <span className="text-xs font-700 text-foreground">KES {(item.product.price * item.qty).toLocaleString()}</span>
                  </div>
              )}
                <div className="flex justify-between pt-2 mt-1">
                  <span className="text-sm font-700" style={{ color: 'var(--primary)' }}>Total</span>
                  <span className="text-sm font-800" style={{ color: 'var(--primary)' }}>KES {total.toLocaleString()}</span>
                </div>
              </div>
            </div>
          }

          {checkoutStep === 'success' &&
          <div className="flex flex-col items-center justify-center h-full gap-4 text-center">
              <div className="w-20 h-20 rounded-full flex items-center justify-center" style={{ background: 'rgba(0,200,83,0.12)', border: '2px solid var(--primary)' }}>
                <Check size={36} style={{ color: 'var(--primary)' }} />
              </div>
              <h3 className="text-xl font-700 text-foreground">Order Placed!</h3>
              <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>Your order has been placed successfully. You will receive a confirmation shortly.</p>
              <div className="p-4 rounded-2xl w-full" style={{ background: 'var(--secondary)', border: '1px solid var(--border)' }}>
                <p className="text-xs font-700 mb-1" style={{ color: 'var(--muted-foreground)' }}>ORDER TOTAL</p>
                <p className="text-2xl font-800" style={{ color: 'var(--primary)' }}>KES {total.toLocaleString()}</p>
              </div>
            </div>
          }
        </div>

        {cart.length > 0 && checkoutStep !== 'success' &&
        <div className="px-5 py-4" style={{ borderTop: '1px solid var(--border)' }}>
            <div className="flex justify-between mb-3">
              <span className="text-sm font-600 text-foreground">Total</span>
              <span className="text-base font-800" style={{ color: 'var(--primary)' }}>KES {total.toLocaleString()}</span>
            </div>
            <button onClick={() => setCheckoutStep(checkoutStep === 'cart' ? 'checkout' : 'success')}
          className="w-full py-3.5 rounded-2xl text-sm font-700"
          style={{ background: 'var(--primary)', color: '#001A08' }}>
              {checkoutStep === 'cart' ? 'Proceed to Checkout' : 'Place Order'}
            </button>
          </div>
        }
      </div>
    </div>);

}

// ─── Main Page ────────────────────────────────────────────────────────────────
export default function BeautyFashionPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [activeSubcategory, setActiveSubcategory] = useState('');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [cart, setCart] = useState<CartItem[]>([]);
  const [wishlist, setWishlist] = useState<Set<string>>(new Set());
  const [showCart, setShowCart] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [sortBy, setSortBy] = useState('featured');
  const [priceRange, setPriceRange] = useState<[number, number]>([0, 50000]);

  const filtered = PRODUCTS.filter((p) => {
    const matchCat = activeCategory === 'All' || p.category === activeCategory;
    const matchSub = !activeSubcategory || p.subcategory === activeSubcategory;
    const matchSearch = !search || p.name.toLowerCase().includes(search.toLowerCase()) || p.seller.toLowerCase().includes(search.toLowerCase());
    const matchPrice = p.price >= priceRange[0] && p.price <= priceRange[1];
    return matchCat && matchSub && matchSearch && matchPrice;
  }).sort((a, b) => {
    if (sortBy === 'price-low') return a.price - b.price;
    if (sortBy === 'price-high') return b.price - a.price;
    if (sortBy === 'rating') return b.rating - a.rating;
    return 0;
  });

  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const paged = filtered.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);

  const addToCart = (product: Product, qty: number, color: string, size: string) => {
    setCart((prev) => {
      const existing = prev.find((i) => i.product.id === product.id);
      if (existing) return prev.map((i) => i.product.id === product.id ? { ...i, qty: i.qty + qty } : i);
      return [...prev, { product, qty, color, size }];
    });
  };

  const toggleWishlist = (id: string) => {
    setWishlist((prev) => {const n = new Set(prev);n.has(id) ? n.delete(id) : n.add(id);return n;});
  };

  const removeFromCart = (id: string) => setCart((prev) => prev.filter((i) => i.product.id !== id));
  const updateCartQty = (id: string, qty: number) => setCart((prev) => prev.map((i) => i.product.id === id ? { ...i, qty } : i));

  const cartCount = cart.reduce((s, i) => s + i.qty, 0);

  const subcategories = activeCategory !== 'All' ? SUBCATEGORIES[activeCategory] || [] : [];

  return (
    <AppLayout>
      <div className="min-h-screen" style={{ background: 'var(--background)' }}>
        {/* Header */}
        <div className="sticky top-0 z-30 px-4 pt-4 pb-3" style={{ background: 'var(--background)', borderBottom: '1px solid var(--border)' }}>
          <div className="flex items-center justify-between mb-3">
            <div>
              <h1 className="text-xl font-800 text-foreground">Beauty & Fashion</h1>
              <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>{filtered.length} products available</p>
            </div>
            <div className="flex items-center gap-2">
              <button onClick={() => setShowFilters(!showFilters)} className="p-2.5 rounded-xl" style={{ background: showFilters ? 'rgba(0,200,83,0.12)' : 'var(--secondary)', border: `1px solid ${showFilters ? 'rgba(0,200,83,0.4)' : 'var(--border)'}` }}>
                <SlidersHorizontal size={18} style={{ color: showFilters ? 'var(--primary)' : 'var(--muted-foreground)' }} />
              </button>
              <button onClick={() => setShowCart(true)} className="relative p-2.5 rounded-xl" style={{ background: 'var(--secondary)', border: '1px solid var(--border)' }}>
                <ShoppingCart size={18} style={{ color: 'var(--foreground)' }} />
                {cartCount > 0 &&
                <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-700" style={{ background: 'var(--primary)', color: '#001A08' }}>{cartCount}</span>
                }
              </button>
            </div>
          </div>

          <div className="relative mb-3">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: 'var(--muted-foreground)' }} />
            <input value={search} onChange={(e) => {setSearch(e.target.value);setPage(1);}} placeholder="Search products, brands, sellers..."
            className="w-full pl-9 pr-4 py-2.5 rounded-xl text-sm outline-none" style={{ background: 'var(--input)', border: '1px solid var(--border)', color: 'var(--foreground)' }} />
          </div>

          <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
            {CATEGORIES.map((cat) =>
            <button key={cat} onClick={() => {setActiveCategory(cat);setActiveSubcategory('');setPage(1);}}
            className="flex-shrink-0 px-4 py-1.5 rounded-xl text-xs font-600"
            style={{ background: activeCategory === cat ? 'var(--primary)' : 'var(--secondary)', color: activeCategory === cat ? '#001A08' : 'var(--muted-foreground)', border: `1px solid ${activeCategory === cat ? 'var(--primary)' : 'var(--border)'}` }}>
                {cat}
              </button>
            )}
          </div>

          {subcategories.length > 0 &&
          <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide mt-2">
              <button onClick={() => {setActiveSubcategory('');setPage(1);}}
            className="flex-shrink-0 px-3 py-1 rounded-xl text-[11px] font-600"
            style={{ background: !activeSubcategory ? 'rgba(0,200,83,0.12)' : 'var(--secondary)', color: !activeSubcategory ? 'var(--primary)' : 'var(--muted-foreground)', border: `1px solid ${!activeSubcategory ? 'rgba(0,200,83,0.3)' : 'var(--border)'}` }}>
                All {activeCategory}
              </button>
              {subcategories.map((sub) =>
            <button key={sub} onClick={() => {setActiveSubcategory(sub);setPage(1);}}
            className="flex-shrink-0 px-3 py-1 rounded-xl text-[11px] font-600"
            style={{ background: activeSubcategory === sub ? 'rgba(0,200,83,0.12)' : 'var(--secondary)', color: activeSubcategory === sub ? 'var(--primary)' : 'var(--muted-foreground)', border: `1px solid ${activeSubcategory === sub ? 'rgba(0,200,83,0.3)' : 'var(--border)'}` }}>
                  {sub}
                </button>
            )}
            </div>
          }

          {showFilters &&
          <div className="mt-3 p-4 rounded-2xl flex flex-col gap-3" style={{ background: 'var(--secondary)', border: '1px solid var(--border)' }}>
              <div className="flex items-center justify-between">
                <p className="text-xs font-700 text-foreground">Sort By</p>
                <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}
              className="text-xs px-3 py-1.5 rounded-xl outline-none" style={{ background: 'var(--input)', border: '1px solid var(--border)', color: 'var(--foreground)' }}>
                  <option value="featured">Featured</option>
                  <option value="price-low">Price: Low to High</option>
                  <option value="price-high">Price: High to Low</option>
                  <option value="rating">Top Rated</option>
                </select>
              </div>
              <div>
                <p className="text-xs font-700 text-foreground mb-2">Price Range: KES {priceRange[0].toLocaleString()} – KES {priceRange[1].toLocaleString()}</p>
                <input type="range" min={0} max={50000} step={500} value={priceRange[1]}
              onChange={(e) => {setPriceRange([priceRange[0], parseInt(e.target.value)]);setPage(1);}}
              className="w-full" />
              </div>
            </div>
          }
        </div>

        <div className="px-4 py-4">
          <div className="flex items-center justify-between mb-3">
            <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
              Showing {Math.min((page - 1) * ITEMS_PER_PAGE + 1, filtered.length)}–{Math.min(page * ITEMS_PER_PAGE, filtered.length)} of {filtered.length} products
            </p>
          </div>

          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
            {paged.map((product) =>
            <div key={product.id} className="rounded-2xl overflow-hidden cursor-pointer transition-all active:scale-95"
            style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
            onClick={() => setSelectedProduct(product)}>
                <div className="relative">
                  <img src={product.image} alt={product.name} className="w-full h-44 object-cover" />
                  {product.badge &&
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded-lg text-[10px] font-700"
                style={{ background: badgeColors[product.badge]?.bg || '#00C853', color: badgeColors[product.badge]?.text || '#000' }}>
                      {product.badge}
                    </span>
                }
                  <button onClick={(e) => {e.stopPropagation();toggleWishlist(product.id);}}
                className="absolute top-2 right-2 w-8 h-8 rounded-full flex items-center justify-center"
                style={{ background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}>
                    <Heart size={14} fill={wishlist.has(product.id) ? '#FF3B5C' : 'none'} style={{ color: wishlist.has(product.id) ? '#FF3B5C' : '#fff' }} />
                  </button>
                </div>
                <div className="p-3">
                  <p className="text-xs font-700 text-foreground leading-tight mb-1 line-clamp-2">{product.name}</p>
                  <div className="flex items-center gap-1 mb-1">
                    <Star size={10} fill="#FFB300" style={{ color: '#FFB300' }} />
                    <span className="text-[10px] font-600 text-foreground">{product.rating}</span>
                    <span className="text-[10px]" style={{ color: 'var(--muted-foreground)' }}>({product.reviews})</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <span className="text-sm font-800" style={{ color: 'var(--primary)' }}>KES {product.price.toLocaleString()}</span>
                    {product.originalPrice > product.price &&
                  <span className="text-[10px] line-through" style={{ color: 'var(--muted-foreground)' }}>KES {product.originalPrice.toLocaleString()}</span>
                  }
                  </div>
                  <p className="text-[10px] mt-1 flex items-center gap-1" style={{ color: 'var(--muted-foreground)' }}>
                    <MapPin size={9} />{product.sellerLocation}
                  </p>
                </div>
              </div>
            )}
          </div>

          {filtered.length === 0 &&
          <div className="flex flex-col items-center justify-center py-16 gap-3">
              <Package size={48} style={{ color: 'var(--muted-foreground)', opacity: 0.3 }} />
              <p className="text-sm font-600 text-foreground">No products found</p>
              <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>Try adjusting your filters</p>
              <button onClick={() => {setActiveCategory('All');setActiveSubcategory('');setSearch('');}}
            className="px-4 py-2 rounded-xl text-xs font-600" style={{ background: 'var(--primary)', color: '#001A08' }}>
                Clear Filters
              </button>
            </div>
          }

          {totalPages > 1 &&
          <div className="flex items-center justify-center gap-2 mt-6">
              <button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1}
            className="flex items-center gap-1 px-4 py-2 rounded-xl text-xs font-600 disabled:opacity-40"
            style={{ background: 'var(--secondary)', border: '1px solid var(--border)', color: 'var(--foreground)' }}>
                <ChevronLeft size={14} />Prev
              </button>
              <div className="flex gap-1">
                {Array.from({ length: Math.min(totalPages, 5) }).map((_, i) => {
                const pageNum = i + 1;
                return (
                  <button key={i} onClick={() => setPage(pageNum)}
                  className="w-8 h-8 rounded-lg text-xs font-700"
                  style={{ background: page === pageNum ? 'var(--primary)' : 'var(--secondary)', color: page === pageNum ? '#001A08' : 'var(--foreground)', border: `1px solid ${page === pageNum ? 'var(--primary)' : 'var(--border)'}` }}>
                      {pageNum}
                    </button>);

              })}
              </div>
              <button onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={page === totalPages}
            className="flex items-center gap-1 px-4 py-2 rounded-xl text-xs font-600 disabled:opacity-40"
            style={{ background: 'var(--secondary)', border: '1px solid var(--border)', color: 'var(--foreground)' }}>
                Next<ChevronRight size={14} />
              </button>
            </div>
          }
        </div>
      </div>

      {selectedProduct &&
      <ProductDetailModal
        product={selectedProduct}
        onClose={() => setSelectedProduct(null)}
        onAddToCart={addToCart}
        onAddToWishlist={toggleWishlist}
        wishlist={wishlist} />

      }

      {showCart &&
      <CartDrawer
        cart={cart}
        onClose={() => setShowCart(false)}
        onRemove={removeFromCart}
        onUpdateQty={updateCartQty} />

      }
    </AppLayout>);

}